import * as React from "react";
import { observer, inject } from "mobx-react";
import { AdProps, DisplayAdProps } from "./typings";
import { Viewport, ViewSmall, ViewMedium, ViewLarge, ViewExtraLarge } from "bernie-view";
import { classNames } from "uitk-react-utils";

@inject("advertising")
export class Ad extends React.Component<AdProps, {}> {
  public componentDidMount() {
    /* istanbul ignore next */
    if (this.props.advertising) {
      this.props.advertising.includeAd();
    }
  }

  public render() {
    if (this.props.advertising && this.props.advertising.adsSuppressed) {
      return null;
    }

    return (
      <AdView
        data-testid="ad-component"
        flexComponent={this.props.flexComponent}
        context={this.props.context}
        advertising={this.props.advertising}
      />
    );
  }
}

const extraLargeAd = "CT1";
const largeAd = "CT2";
const mediumAd = "CT3";
const smallAd = "CT4";

const DisplayAd = (props: DisplayAdProps) => {
  const { flexComponent, uci, advertising } = props;

  const overrideMarginTop = flexComponent.model.marginTopOverride === "sizing__three";
  const displayAdClassNames = classNames("Ad all-cell-1-1 uitk-cell s-t-margin-six uitk-type-center", {
    "all-y-margin-three": overrideMarginTop,
    "all-y-margin-six": !overrideMarginTop,
    "background-color-white": flexComponent.model.backgroundWhite,
  });

  return (
    <div
      className={displayAdClassNames}
      id={flexComponent.id}
      data-fm={flexComponent.fmId}
      data-fm-title-id={flexComponent.fmTitleId}
      data-testid="display-ad"
      role="banner"
    >
      <meso-display-ad uci={advertising?.adSlotIdOverride || uci} />
    </div>
  );
};

const AdView = observer((props: AdProps) => (
  <Viewport>
    <ViewExtraLarge>
      <DisplayAd
        flexComponent={props.flexComponent}
        context={props.context}
        advertising={props.advertising}
        uci={props.flexComponent.model.extraLargeAd || extraLargeAd}
      />
    </ViewExtraLarge>
    <ViewLarge>
      <DisplayAd
        flexComponent={props.flexComponent}
        context={props.context}
        advertising={props.advertising}
        uci={props.flexComponent.model.largeAd || largeAd}
      />
    </ViewLarge>
    <ViewMedium>
      <DisplayAd
        flexComponent={props.flexComponent}
        context={props.context}
        advertising={props.advertising}
        uci={props.flexComponent.model.mediumAd || mediumAd}
      />
    </ViewMedium>
    <ViewSmall>
      <DisplayAd
        flexComponent={props.flexComponent}
        context={props.context}
        advertising={props.advertising}
        uci={props.flexComponent.model.smallAd || smallAd}
      />
    </ViewSmall>
  </Viewport>
));

(AdView as React.SFC).displayName = "AdView";

export default Ad;
